import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getAllProcess() {
  try {
    const response = await axios.get("/ProcesosP/Procesos/GetAllProcess");
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getProcesos(data) {
  try {
    const response = await axios.post("/ProcesosP/Procesos/Get", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function postProcesos(data) {
  try {
    const response = await axios.post("/ProcesosP/Procesos/Post/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function putProcesos(data) {
  try {
    const response = await axios.put("/ProcesosP/Procesos/Put/", data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}